/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelArCallHistory.ts                 *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/ar/ar-call-history";

export class AutogenModelArCallHistory<RowType extends ModelRow> extends Endpoint<RowType, RowArCallHistoryFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowArCallHistory extends ModelRow<RowArCallHistoryFields> {
	constructor(values?: Partial<RowArCallHistoryFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowArCallHistoryFields {
	action_code_id: string;
	attach_filename: string;
	attachment: string;
	call_date: Date;
	call_detail: string;
	caller_user_id: string;
	closed_date: Date;
	collection_amt: number;
	collection_amt_c: string;
	collection_amt_d: Date;
	collection_amt_n: number;
	collection_amt_r: number;
	collections_id: string;
	company_id: string;
	contact_name: string;
	customer_id: string;
	deposit_no: string;
	id: string;
	invoice_no_string: string;
	name: string;
	nxt_action_code: string;
	nxt_action_date: Date;
	order_id: string;
	reference_number: string;
	remark: string;
	status: string;
}

